/**
 * 长图「智能编排」草稿在「我的作品」草稿卡上的状态(1005 上线前修)。
 *
 * 提交编排后页面直接跳 /works(0911「点完即走」),而编排要跑几分钟;此前作品页只有一条
 * 20 秒就消失的 toast,之后这份稿和没编排过的普通草稿长得一模一样 —— 用户以为没动静。
 * 服务端列表(GET /poster/drafts)一直带着 `planStatus`(从 draftMeta.plan 解,
 * queued|running|done|failed),缺的只是最后一跳:把它显示出来,在途时让列表轮询。
 *
 * ★认不出来的值一律当没有(同视频 draftStatusHint 口径):显示原始枚举名比不显示更糟。
 */
const HINTS: Record<string, string> = {
  queued: "智能编排中 · 约 2–5 分钟",
  running: "智能编排中 · 约 2–5 分钟",
  done: "编排好了 · 点开继续精调",
  failed: "编排失败 · 点开重试",
};

export function planStatusHint(planStatus?: string | null): string | undefined {
  if (!planStatus) return undefined;
  return HINTS[planStatus.toLowerCase()];
}

/** 编排是否还在跑 —— 作品页据此给草稿卡挂「编排中」角标并轮询草稿列表。 */
export function planInFlight(planStatus?: string | null): boolean {
  const s = planStatus?.toLowerCase();
  return s === "queued" || s === "running";
}
